/* eslint-disable */
import uiI18n from "../../i18n";
import axios from "axios";
import Swal from "sweetalert2";

const apicache = async (account, products) => {
  if (!account?.store || !account?.storeName) return;

  const domain = new URL(account?.storeName).hostname;
  const parts = domain.split(".");
  const subdomain = parts.length > 2 ? parts[0] : "";

  let storeName = "";
  if (parts.length > 2) {
    storeName = parts[0];
  }

  const cacheKeys = products.map((product) => product.url);
  const requests = [];

  if (account?.storeName !== account?.store) {
    requests.push(
      axios.post(
        `${account?.storeName}api/revalidate?secret=iusdbviuOiuf14DJIU`,
        {
          slugs: cacheKeys,
          store: subdomain,
        }
      ),
      axios.post(`${account?.store}api/revalidate?secret=iusdbviuOiuf14DJIU`, {
        slugs: cacheKeys,
        store: subdomain,
      })
    );
  } else {
    requests.push(
      axios.post(`${account?.store}api/revalidate?secret=iusdbviuOiuf14DJIU`, {
        slugs: cacheKeys,
        store: subdomain,
      })
    );
  }

  try {
    const results = await Promise.allSettled(requests);
    const successful = results.filter((r) => r.status === "fulfilled");

    if (successful.length > 0) {
      Swal.fire({
        icon: "success",
        title: uiI18n.t("ui.successful"),
        text: uiI18n.t("ui.cacheCleared"),
        confirmButtonText: uiI18n.t("ship.ok"),
        confirmButtonColor: "#7e5395",
        timer: 3000,
        timerProgressBar: true,
        position: "bottom-end",
        toast: true,
        showConfirmButton: false,
      });
    } else {
      Swal.fire({
        icon: "error",
        title: uiI18n.t("Products.ImportModal.error"),
        text: uiI18n.t("ui.cacheClearError"),
        confirmButtonText: uiI18n.t("ship.ok"),
      });
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    Swal.fire({
      icon: "error",
      title: uiI18n.t("Products.ImportModal.error"),
      text: uiI18n.t("ui.cacheUnexpectedError"),
      confirmButtonText: uiI18n.t("ship.ok"),
    });
  }
};

export default apicache;
